import { createStyles } from '@mui/styles';
import { APTheme } from '../../../../core/TenantProvider/tenants';

const commonFooterStyles = () => ({
  textAlign: 'left' as const,
  position: 'relative' as const,
  maxWidth: 1110,
  '@media(max-width: 1200px)': {
    paddingLeft: 110,
    maxWidth: 'none',
    paddingRight: 35,
    margin: 0,
    paddingBottom: 15,
  },
  '@media(max-width: 768px)': {
    paddingLeft: 20,
    paddingRight: 20,
    maxWidth: '90%',
    margin: 'auto',
    textAlign: 'center',
  }
});

export default (theme: APTheme) => createStyles({
  appVersion: {
    fontSize: '1.3rem',
    textAlign: 'right',
    '@media(max-width: 768px)': {
      fontSize: '1.2rem',
      textAlign: 'center',
      lineHeight: '1.6rem',
    },
  },
  footerContainer: {
    borderTop: '1px solid #E8E8E8',
    color: '#A4A4A4',
    margin: '0 35px',
    padding: '20px 0',
    textAlign: 'center',
    '@media(max-width: 1024px)': {
      margin: '0 auto',
      padding: '20px 0',
      maxWidth: '95%',
      textAlign: 'center'
    },
  },
  footerContainerAuthenticated: {
    ...commonFooterStyles(),
    '& p': {
      display: 'inline',
    }
  },
  footerContainerTorFXOz: {
    ...commonFooterStyles(),
    '& p': {
      display: 'block',
    }
  },
  footerLabel: {
    fontSize: '1.3rem',
    lineHeight: '2.5rem',
    '@media(max-width: 1024px)': {
      fontSize: '1.2rem',
      lineHeight: '1.6rem',
    },
  },
  footerText: {

  },
  languageButtons: {
    display: 'flex',
    justifyContent: 'center'
  }
});